"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
require("core-js/modules/es.number.constructor.js");
var _utils = require("../utils");
var _zzUtils = require("@zz-common/zz-utils");
var _use = (0, _utils.use)('image'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  props: {
    src: String,
    fit: {
      type: String,
      default: 'contain'
    },
    alt: String,
    lazyLoad: Boolean,
    width: [String, Number],
    height: [String, Number],
    setPicSize: Number,
    px2rem: Boolean,
    border: Boolean,
    round: Boolean,
    clickeffect: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: true,
      error: false,
      offsetWidth: 0
    };
  },
  watch: {
    src: function src() {
      this.loading = true;
      this.error = false;
    }
  },
  computed: {
    style: function style() {
      var style = {};
      style.width = this.px2rem ? (0, _utils.suffixRem)(this.width) : (0, _utils.suffixPx)(this.width);
      style.height = this.px2rem ? (0, _utils.suffixRem)(this.height) : (0, _utils.suffixPx)(this.height);
      return style;
    },
    size: function size() {
      // 直接乘以2就行， devicePixelRatio 由 setPicSize 自己算
      return this.setPicSize || this.offsetWidth * 2;
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (!this.setPicSize) {
      this.$nextTick(function () {
        _this.offsetWidth = _this.$el.offsetWidth;
      });
    }
  },
  methods: {
    onLoad: function onLoad(event) {
      this.loading = false;
      this.$emit('load', event, this.$refs.img);
    },
    onError: function onError(event) {
      this.error = true;
      this.loading = false;
      this.$emit('error', event, this.$refs.img);
    },
    onClick: function onClick(event) {
      this.$emit('click', event, this.$refs.img);
    },
    renderPlaceholder: function renderPlaceholder() {
      var h = this.$createElement;
      if (this.loading) {
        return h("div", {
          "class": bem('loading')
        }, [this.slots('loading')]);
      }
      if (this.error) {
        return h("div", {
          "class": bem('error')
        }, [this.slots('error') || h("img", {
          "class": bem('error-default'),
          "attrs": {
            "src": (0, _zzUtils.setPicSize)('2a4aab00-549f-4020-accb-7c7cccee3ae6.png', this.size),
            "alt": "error"
          }
        })]);
      }
    },
    renderImage: function renderImage() {
      var h = this.$createElement;
      if (this.error) {
        return;
      }
      var imgData = {
        class: bem('img'),
        attrs: {
          alt: this.alt
        },
        style: {
          objectFit: this.fit
        },
        on: {
          load: this.onLoad,
          error: this.onError
        }
      };

      // 第一次渲染的时候没有取到size，不处理
      // 传'' / undefined不会产生请求，lazyload 特殊处理
      var src = this.src && this.size !== undefined ? (0, _zzUtils.setPicSize)(this.src, this.size) : this.lazyLoad ? '' : undefined;
      if (this.lazyLoad) {
        return h("img", (0, _babelHelperVueJsxMergeProps.default)([{
          "ref": "img",
          "directives": [{
            name: "lazy",
            value: src
          }]
        }, imgData]));
      }
      return h("img", (0, _babelHelperVueJsxMergeProps.default)([{
        "ref": "img",
        "attrs": {
          "src": src
        }
      }, imgData]));
    }
  },
  render: function render(h) {
    return h("div", {
      "class": [bem(), {
        'z-hairline--surround': this.border,
        'z-image--round': this.round,
        'click-effect': this.clickeffect
      }],
      "style": this.style,
      "on": {
        "click": this.onClick
      }
    }, [this.renderImage(), this.renderPlaceholder()]);
  }
});
exports.default = _default;